define('plugin/invoice/model/InvoiceModel',['require','lib/model/BaseModel','plugin/invoice/collection/InvoiceTaxCollection','plugin/invoice/collection/InvoiceLineCollection','plugin/invoice/collection/InvoicePromotionInstanceCollection','plugin/invoice/collection/InvoicePackageInstanceCollection','Config'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var InvoiceTaxCollection = require('plugin/invoice/collection/InvoiceTaxCollection');
    var InvoiceLineCollection = require('plugin/invoice/collection/InvoiceLineCollection');
    var InvoicePromotionInstanceCollection = require('plugin/invoice/collection/InvoicePromotionInstanceCollection');
    var InvoicePackageInstanceCollection = require('plugin/invoice/collection/InvoicePackageInstanceCollection');
    var Config = require('Config');

    /**
     * Invoice model
     *
     * @class InvoiceModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/invoice/details/id',
        applyPromoUrlRoot: '/v2/ext/invoice/promotion/id',
        applyTipsUrlRoot: '/v2/ext/invoice/tips/id',
        applyPackageUrlRoot: '/v2/ext/invoice/package/id',
        payDepositAmountUrlRoot: '/v2/ext/invoice/pay-deposit-amount/id',
        payFullAmountUrlRoot: '/v2/ext/invoice/pay-full-amount/id',
        rebillingUrl: '/v2/ext/invoice/pay/id',

        defaults: {
            id: null,
            client_id: null,
            datetime: null,
            due_datetime: null,
            description: '',
            number: '',
            status: 'new',
            amount: 0,
            rest_amount: 0,
            amount_with_rest_amount: 0,
            currency: '',
            taxes: null,
            lines: null
        },
        _promotionError: null,
        _tipsError: null,
        _packageError: null,
        _depositError: null,

        initialize: function () {
            BaseModel.prototype.initialize.apply(this, arguments);

            this.initSubCollections();
        },

        parse: function (resp, options) {
            var result = BaseModel.prototype.parse.apply(this, [resp, options]);

            this.initSubCollections();

            this.get('taxes').reset(result.taxes);
            this.get('lines').reset(result.lines);
            this.get('promotion_instances').reset(result.promotion_instances);
            this.get('package_instances').reset(result.package_instances);

            result.taxes = this.get('taxes');
            result.lines = this.get('lines');
            result.promotion_instances = this.get('promotion_instances');
            result.package_instances = this.get('package_instances');

            return result;
        },

        initSubCollections: function () {
            if (!this.get('taxes') || _.isArray(this.get('taxes'))) {
                var taxes = this.get('taxes') || [];
                this.set('taxes', new InvoiceTaxCollection(taxes), {silent: true});
            }
            if (!this.get('lines') || _.isArray(this.get('lines'))) {
                var lines = this.get('lines') || [];
                this.set('lines', new InvoiceLineCollection(lines), {silent: true});
            }
            if (!this.get('promotion_instances') || _.isArray(this.get('promotion_instances'))) {
                var promotionInstances = this.get('promotion_instances') || [];
                this.set('promotion_instances', new InvoicePromotionInstanceCollection(promotionInstances), {silent: true});
            }
            if (!this.get('package_instances') || _.isArray(this.get('package_instances'))) {
                var packageInstances = this.get('package_instances') || [];

                this.set('package_instances', new InvoicePackageInstanceCollection(packageInstances), {silent: true});
            }
        },

        pay: function (paymentMethodId, recurring) {
            var options = {
                parse: false,
                attrs: {
                    payment_method_id: paymentMethodId,
                    recurring: recurring
                },
                url: this.rebillingUrl + '/' + this.get('id')
            };

            return this.syncWithPromise('update', options);
        },

        applyPackage: function (packageInstanceId) {
            this._packageError = null;

            var options = {
                parse: true,
                attrs: {
                    package_instance_id: packageInstanceId
                },
                url: this.applyPackageUrlRoot + '/' + this.get('id')
            };

            this.syncWithPromise('update', options).then(null, _.bind(function (data) {
                this._packageError = data.error;
                this.trigger('error:package', this._packageError);
            }, this));
        },

        applyPromoCode: function (code) {
            this._promotionError = null;

            var options = {
                parse: true,
                attrs: {
                    code: code
                },
                url: this.applyPromoUrlRoot + '/' + this.get('id')
            };

            this.syncWithPromise('update', options).then(null, _.bind(function (data) {
                this._promotionError = data.error;
                this.trigger('error:promotion', this._promotionError);
            }, this));
        },

        applyTips: function (tips, amount) {
            this._tipsError = null;

            var data = {
                tips: tips
            };

            if (amount) {
                data.tips_amount = amount;
            }

            var options = {
                parse: true,
                attrs: data,
                url: this.applyTipsUrlRoot + '/' + this.get('id')
            };

            this.syncWithPromise('update', options).then(null, _.bind(function (data) {
                this._tipsError = data.error;
                this.trigger('error:tips', this._tipsError);
            }, this));
        },

        removePackage: function (id) {
            this._promotionError = null;

            var options = {
                parse: true,
                url: this.applyPackageUrlRoot + '/' + this.get('id') + '/instance-id/' + id
            };

            this.syncWithPromise('delete', options).then(null, _.bind(function (data) {
                this._packageError = data.error;
                this.trigger('error:package', this._packageError);
            }, this));
        },

        removePromoCode: function (id) {
            this._promotionError = null;

            var options = {
                parse: true,
                url: this.applyPromoUrlRoot + '/' + this.get('id') + '/instance-id/' + id
            };

            this.syncWithPromise('delete', options).then(null, _.bind(function (data) {
                this._promotionError = data.error;
                this.trigger('error:promotion', this._promotionError);
            }, this));
        },

        removeTips: function (id) {
            this._tipsError = null;

            var options = {
                parse: true,
                url: this.applyTipsUrlRoot + '/' + this.get('id') + '/instance-id/' + id
            };

            this.syncWithPromise('delete', options).then(null, _.bind(function (data) {
                this._tipsError = data.error;
                this.trigger('error:tips', this._tipsError);
            }, this));
        },

        payDepositAmount: function () {
            this._depositError = null;

            var options = {
                parse: true,
                url: this.payDepositAmountUrlRoot + '/' + this.get('id')
            };

            this.syncWithPromise('update', options).then(null, _.bind(function (data) {
                this._depositError = data.error;
                this.trigger('error:deposit', this._depositError);
            }, this));
        },

        payFullAmount: function () {
            this._depositError = null;

            var options = {
                parse: true,
                url: this.payFullAmountUrlRoot + '/' + this.get('id')
            };

            this.syncWithPromise('update', options).then(null, _.bind(function (data) {
                this._depositError = data.error;
                this.trigger('error:deposit', this._depositError);
            }, this));
        },

        getPromotionError: function () {
            return this._promotionError;
        },

        getTipsError: function () {
            return this._tipsError;
        },

        getPackageError: function () {
            return this._packageError;
        },

        getLineTypes: function () {
            var result = {
                'has_bookings': false,
                'has_promotions': false,
                'promotion_instance_id': null,
                'has_memberships': false,
                'has_packages': false,
                'has_products': false,
            };
            this.get('lines').each(function (model) {
                switch (model.get('type')) {
                    case 'promotion':
                        result.has_promotions = true;
                        result.promotion_instance_id = model.get('promotion_instance_id');
                        break;

                    case 'tips':
                        result.has_tips = true;
                        break;
                    case 'booking':
                    case 'deposit':
                        result.has_bookings = true;
                        break;
                    case 'membership':
                        result.has_memberships = true;
                        break;
                    case 'package':
                        result.has_packages = true;
                        break;
                    case 'product':
                        result.has_products = true;
                }
            });
            return result;
        },

        getBookingIds: function () {
            var result = [];
            this.get('lines').each(function (model) {
                if (model.get('type') === 'booking' || model.get('type') === 'deposit') {
                    _.each(model.get('booking_ids'), function (id) {
                        result.push(id);
                    });
                }
            });
            return result;
        },

        isPaymentAllowed: function () {
            return this.get('status') === 'new' ||
                this.get('status') === 'pending' ||
                this.get('status') === 'cancelled' ||
                this.get('status') === 'error' ||
                (this.get('status') === 'paid' && !this.get('payment_received'));
        },

        isPrintAllowed: function () {
            return this.get('sbpay_invoice_id') || this.get('payment_received') || !Config.getInstance().sbPayInvoicesEnabled();
        }

    });

});
